import styled from '@emotion/styled'

export const InvoiceEditorPreviewWrapper = styled.div`
  width: 100%;
  min-height: 80vh;
  background-color: transparent;
`
